import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { User } from '../models/user';
import { UserStatus } from '../models/user-status';
import {AccountType} from '../models/account-type';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  accessToken = this.getFromRepository('accessToken');
  email = this.getFromRepository('email');
  isWaitingConfirmation = this.getFromRepository('isWaitingConfirmation') === 'true';
  vid = this.getFromRepository('vid');
  phone = this.getFromRepository('phone');

  get isAdmin(): boolean {
    return this.getFromRepository('isAdmin') === 'true';
  }

  public isUserLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.accessToken != null);

  constructor(private router: Router) { }

  waitForConfirmation(vid: number, phone: string): void {
    if (phone) {

      this.accessToken = null;
      this.removeFromRepository('accessToken');

      this.vid = vid.toString();
      this.saveInRepository('vid', vid.toString());

      this.phone = phone;

      this.saveInRepository('phone', phone);

      this.isWaitingConfirmation = true;
      this.saveInRepository('isWaitingConfirmation', 'true');
    }
  }

  login(accessToken: string): void {
    if (accessToken) {
      this.accessToken = accessToken;
      this.saveInRepository('accessToken', accessToken);

      this.isWaitingConfirmation = false;
      this.removeFromRepository('isWaitingConfirmation');

      this.isUserLoggedIn.next(true);
    }
  }

  loginEditbleUer(user: User) {
    this.login(user.accessToken);
    this.saveInRepository('email', user.email);
    this.saveInRepository('phone', user.phone);
    this.saveInRepository('vid', user.vid.toString());
    this.saveInRepository('isAdmin', 'true');
    this.phone = user.phone;
    this.email = user.email;
    this.vid = user.vid.toString();

    this.router.navigate(['']);
  }

  logout(): void {
    this.removeFromRepository('accessToken');
    this.removeFromRepository('email');
    this.removeFromRepository('isWaitingConfirmation');
    this.removeFromRepository('vid');
    this.removeFromRepository('isAdmin');
    this.removeFromRepository('applicationStatus');

    this.accessToken = null;
    this.email = null;
    this.isWaitingConfirmation = null;
    this.vid = null;

    this.isUserLoggedIn.next(false);
  }

  setUserStatus(user: User, isAdmin: boolean) {
    this.saveInRepository('userStatus', JSON.stringify({
      applicationStatus: user.applicationStatus,
      hasProofAddressDocument: user.proofAddressDocument != null,
      hasProofIdentetyDocument: user.proofIdentetyDocument != null,
      documentsNotRequired: user.documentsNotRequired,
      accountType: user.accountType,
      isAdmin
    }));
  }

  getUserStatus(): UserStatus {
    return JSON.parse(this.getFromRepository('userStatus')) as UserStatus;
  }

  public isLoggedIn(): boolean {
    if (this.accessToken) { return true; }
  }

  public waitingConfirmation(): boolean {
    if (!this.accessToken && this.phone && this.isWaitingConfirmation) { return true; }
  }

  private saveInRepository(key: string, value: string): void {
    sessionStorage.setItem(key, value); // todo add local storage service
  }

  private removeFromRepository(key: string): void {
    sessionStorage.removeItem(key);
  }

  public getFromRepository(key: string): string {
    return sessionStorage.getItem(key);
  }
}
